import React, {Component} from 'react';

import RosterHeaderView from 'shared_features/roster_header';
import FilterView from './category_filters';
import ResultsView from './results';
import ColumnsFilterView from './columns_filter';
import ImportAthletesView from './import_athletes';
import MacroView from './macro_footer';
import GroupInviteLink from './group_invite';
import styles from './styles.module.scss';

import { connect } from 'react-redux';
import { FETCH_GROUP_INVITE_LINKS_REQUESTED } from 'shared_redux/actions/group_invite_links';

class View extends Component {
    componentDidMount() {
        this.fetchInviteLinksForCurrentGroup();
    }
    
    componentDidUpdate(prevProps) {
        // Check if the URL has changed (navigation between groups)
        if (prevProps.location?.search !== this.props.location?.search) {
            this.fetchInviteLinksForCurrentGroup();
        }
    }
    
    fetchInviteLinksForCurrentGroup() {
        if (this.props.location) {
            const searchParams = new URLSearchParams(this.props.location.search);
            const groupId = searchParams.get('group_id');
            
            if (groupId && this.props.fetchInviteLinks) {
                console.log('[List View] Fetching invite links for group:', groupId);
                this.props.fetchInviteLinks(groupId);
            }
        }
    }

    render() {
        return (
            <div>
                <RosterHeaderView />
                <div className={styles.main}>
                    <div className={styles.grid}>
                        <FilterView />
                        <ResultsView />
                    </div>
                    <MacroView />
                    <ImportAthletesView />
                    <ColumnsFilterView />
                    {this.props.location && (() => {
                        // Extract group ID from URL search params
                        const searchParams = new URLSearchParams(this.props.location.search);
                        const groupIdFromUrl = searchParams.get('group_id');
                        console.debug('URL group_id:', groupIdFromUrl);
                        
                        return (
                            <ResultsView.GroupInviteLink 
                                groupId={groupIdFromUrl}
                            />
                        );
                    })()}
                </div>
            </div>
        );
    }
};

const mapDispatchToProps = (dispatch) => ({
    fetchInviteLinks: (groupId) => dispatch({
        type: FETCH_GROUP_INVITE_LINKS_REQUESTED,
        payload: { groupId }
    })
});

export default connect(null, mapDispatchToProps)(View);
